<template>
  <fieldset class="c-options">
    <legend class="c-form__label c-options__question">{{label}}</legend>

    <div
      v-for="(option, key) in options"
      :class="{'c-options__answer': true, 'is-selected': option.value == inputValue}"
    >
      <input
        class="c-options__input"
        type="radio"
        :id="name + '_' + key"
        :name="name"
        :value="option.value"
        v-model="inputValue"
      >
      <label class="c-options__label" :for="name + '_' + key" :class="{'p-bottom-10': option.content == ''}">
        <icon v-if="option.value == inputValue" class="c-options__icon" name="tick"></icon>
        <span class="c-options__label-text">{{option.label}}</span>
        <span class="c-options__content" v-if="option.content && option.content != ''">{{option.content}}</span>
      </label>
    </div>
    <div>
      <span class="c-form__validation-message" v-if="error && inputValue">{{ error }} {{ inputValue }}</span>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'form-options',

  props: {
    label: String,
    name: String,
    options: [Array],
    value: [String, Number],
    error: String,
  },

  $_veeValidate: {
    value() {
      return this.inputValue;
    },
  },

  data() {
    return {
      inputValue: this.value,
    };
  },

  computed: {
    //
  },

  watch: {
    inputValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>


<style lang="scss">
.c-options {
  border: none;
  padding: 0;
  width: 100%;
  margin-bottom: 2em;

  // <legend>
  &__question {
    //
  }

  // <div>
  &__answer {
    width: 33.333%;
    display: inline-block;
    padding-right: 1em;
  }

  &__answer.is-selected {
  }

  // div.__answer  ->  <input type='radio'>
  &__input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  // div.__answer  ->  <label>
  &__label {
    display: block;
    display: block;
    height: 100%;
    width: 100%;
    background: $colour-nhs-white;
    border: 2px solid #c9ced4;
    position: relative;

    cursor: pointer;
    border-radius: 4px;

    padding: 10px 10px 30px 10px;
  }

  &__answer.is-selected &__label {
    border-color: $colour-nhs-blue;
  }

  &__label-text {
    font-weight: bold;
  }

  &__icon {
    background: #0cce4e;
    border-radius: 100%;
    height: 32px;
    width: 32px;
    padding: 8px;
    color: $colour-nhs-white;

    position: absolute;
    top: -16px;
    right: -16px;
  }

  &__content {
    margin-top: 1em;
    display: block;
  }
}
</style>

